import { render, staticRenderFns } from "./groupLinks.vue?vue&type=template&id=1a9abd28&scoped=true&"
import script from "./groupLinks.vue?vue&type=script&lang=js&"
export * from "./groupLinks.vue?vue&type=script&lang=js&"
import style0 from "./groupLinks.vue?vue&type=style&index=0&id=1a9abd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9abd28",
  null
  
)

export default component.exports